import { createContext } from 'react';
import { IconBadgeListItem } from '../../molecules/IconBadgeList';

export type HeaderNotificationsContextValue = {
    itemsMessage?: IconBadgeListItem[];
    itemsNotification?: IconBadgeListItem[];
};

export const HeaderNotificationsContext = createContext<HeaderNotificationsContextValue>({});
